import { useEffect, useState } from 'react';
import { useCSSProperty } from './useCSSProperty';

export const useCSSPropertys = () => {
    const [isSupportCqh, setIsSupportCqh] = useState(true);
    const [isSupportAspectRatio, setIsSupportAspectRatio] = useState(true);
    useEffect(() => {
        // support from ios 15
        const isar = CSS.supports('aspect-ratio: 1');
        // support from ios 16
        const isc = CSS.supports('container-type', 'size');
        setIsSupportAspectRatio(isar && isc);
        setIsSupportCqh(isc);
    }, []);

    const { setValue: setTableMaskCqh } = useCSSProperty({
        key: '--table-mask-cqh',
        defaultValue: '1px',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setTableFullCellCqh } = useCSSProperty({
        key: '--table-revamp-full-cell-cqh',
        defaultValue: '1px',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setTableGridCellCqh } = useCSSProperty({
        key: '--table-revamp-grid-cell-cqh',
        defaultValue: '1px',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setTableMiniCellCqh } = useCSSProperty({
        key: '--table-revamp-mini-cell-cqh',
        defaultValue: '1px',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setMultibetGridCellHeaderCqh } = useCSSProperty({
        key: '--multibet-grid-cell-header-cqh',
        defaultValue: '0',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setMultibetGridCellBetAreaCqh } = useCSSProperty({
        key: '--multibet-grid-cell-bet-area-cqh',
        defaultValue: '0',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setMultibetHeightCqw } = useCSSProperty({
        key: '--multibet-video-height-cqw',
        defaultValue: '0',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setMultibetWidthCqh } = useCSSProperty({
        key: '--multibet-video-width-cqh',
        defaultValue: '0',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setBetViewCqh } = useCSSProperty({
        key: '--bet-view-cqh',
        defaultValue: '0',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setECardCqh } = useCSSProperty({
        key: '--e-card-cqh',
        defaultValue: '0',
        isSupportCqh: isSupportCqh,
    });

    const { setValue: setMultiBetVideoHeight } = useCSSProperty({
        key: '--multibet-video-height',
        defaultValue: '1px',
        isSupportCqh: isSupportCqh,
    });
    // const { setValue: setMultiBetVideoWidth } = useCSSProperty({
    //     key: '--multibet-video-width',
    //     defaultValue: '1px',
    // });
    const { setValue: setMultiBetVideoTop } = useCSSProperty({
        key: '--multibet-video-top',
        defaultValue: '-1000px',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setMultiBetVideoLeft } = useCSSProperty({
        key: '--multibet-video-left',
        defaultValue: '-1000px',
        isSupportCqh: isSupportCqh,
    });
    const { setValue: setMultiBetVideoPlace } = useCSSProperty({
        key: '--multi-bet-video',
        defaultValue: 'auto',
        isSupportCqh: isSupportCqh,
    });

    return {
        isSupportCqh,
        isSupportAspectRatio,
        setTableMaskCqh,
        setTableFullCellCqh,
        setTableGridCellCqh,
        setTableMiniCellCqh,
        setMultibetGridCellHeaderCqh,
        setMultibetGridCellBetAreaCqh,
        setBetViewCqh,
        setECardCqh,
        setMultibetHeightCqw,
        setMultibetWidthCqh,
        setMultiBetVideoHeight,
        // setMultiBetVideoWidth,
        setMultiBetVideoTop,
        setMultiBetVideoLeft,
        setMultiBetVideoPlace,
    };
};

export type useCSSPropertyState = ReturnType<typeof useCSSPropertys>;
